<template>
  <div class="calendar">
    <div class="calendar-head">
      <!-- <el-scrollbar>
        <ul class="month-nav">
          <li
            v-for="(month, index) in months"
            :key="index"
            class="month-nav__item flex-none"
            :class="{
              'is-selected': selectedMonth.isSame(month, 'month')
            }"
            @click="onMonthClick(month)"
          >
            {{ month.format("YY年MM月") }}
          </li>
        </ul>
      </el-scrollbar> -->
      <el-tabs
        class="month-nav"
        :value="selectedMonth.format('YYYY-MM')"
        @input="onTabChange"
      >
        <el-tab-pane
          v-for="(month, index) in months"
          :key="index"
          :name="month.format('YYYY-MM')"
          :label="month.format('YY年MM月')"
        />
      </el-tabs>
    </div>
    <v-calendar
      class="calendar-body w-full"
      :value="selectedMonth"
      :selectedValue="selectedDate"
      @update:selectedValue="onDateSelect"
      :disabled-date="disabledDate"
    >
      <!-- <v-calendar-cell /> -->
      <template #day-cell="{ date, selected, disabled }">
        <calendar-cell
          :date="date"
          :selected="selected"
          :disabled="disabled"
          :stock="getDateStock(date)"
        />
      </template>
    </v-calendar>
  </div>
</template>
<script>
import VCalendar from "@/components/VCalendar/index.vue";
import VacationDetailCalendarCell from "@/views/product/VacationDetailCalendarCell.vue";
import { dayjs, head } from "@/utils/helpers";
import { computed, ref } from '@nuxtjs/composition-api';
export default {
  name: "VacationDetailCalendar",
  components: { VCalendar, CalendarCell: VacationDetailCalendarCell },
  props: {
    stocks: {
      type: Array,
      default: () => [],
    },
    dates: {
      type: Array,
      default: () => [],
    },
    // months: {
    //   type: Array,
    //   default: () => []
    // },
    selectedStock: Object,
  },
  setup(props) {
    const selectedMonth = ref(dayjs());
    const months = computed(() => {
      return props.dates.map((date) =>
        dayjs(`${date.year}-${date.month}`, "yyyy-MM")
      );
    });
    return {
      months,
      selectedMonth,
    };
  },
  data() {
    return {
      // selectedDate: dayjs(),
    };
  },
  computed: {
    selectedDate() {
      if (this.selectedStock && this.selectedStock.date) {
        return dayjs(this.selectedStock.date);
      }
      return dayjs();
    },
  },
  watch: {
    months: {
      handler(months) {
        if (months && months.length) {
          this.selectedMonth = head(months);
        }
      },
      immediate: true,
    },
  },
  methods: {
    disabledDate(date) {
      return !this.stocks.some((stock) => date.isSame(stock.date, "day"));
    },
    getDay(date) {
      return date.getDate();
    },
    getDateStock(date) {
      // console.log(date.format('YYYY-MM-DD'), 'MMMMMMMMMMMMMM')
      return this.stocks.find((stock) => {
        // console.log(date.isSame(stock.date, 'day'), stock.date, date.format('YYYY-MM-DD'), 'getDateStock')
        return date.isSame(stock.date, "day");
      });
    },
    onMonthClick(month) {
      this.selectedMonth = month;
    },
    onDateSelect(date) {
      let stock = this.stocks.find((stock) => date.isSame(stock.date, "day"));
      console.log('date-select', date.format('YYYY-MM-DD'), this.stocks)
      if(!stock){
        return
      }
      this.$emit("update:selectedStock", stock);

      this.$nextTick(() => {
        this.$emit('selected-stock-change', stock)
      })
    },
    onTabChange(event) {
      this.selectedMonth = dayjs(event);
    },
  },
};
</script>
<style lang="scss" scoped>
.calendar-body {
  border: $border-base;
}
.calendar-body ::v-deep .table-header-group {
  line-height: 1.75rem;
  border-bottom: $border-base;
}
.calendar-body ::v-deep .table-header-group .table-cell {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  text-align: center;
}
::v-deep .month-nav {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
::v-deep .month-nav .el-tabs__nav-wrap::after {
  display: none;
}
::v-deep .month-nav .el-tabs__item {
  height: 1.5rem;
  line-height: 1.5rem;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
::v-deep .month-nav .el-tabs__nav-prev, ::v-deep .month-nav .el-tabs__nav-next {
  --tw-bg-opacity: 1;
  background-color: rgba(242, 242, 242, var(--tw-bg-opacity));
  border-radius: 0.375rem;
  height: 1.5rem;
  line-height: 1.5rem;
  text-align: center;
  width: 1.5rem;
}
::v-deep .month-nav .el-tabs__nav-prev:hover, ::v-deep .month-nav .el-tabs__nav-next:hover {
  --tw-text-opacity: 1;
  color: rgba(0, 94, 220, var(--tw-text-opacity));
}
::v-deep .month-nav .el-tabs__nav-prev.is-disabled, ::v-deep .month-nav .el-tabs__nav-next.is-disabled {
  cursor: not-allowed;
  --tw-text-opacity: 1;
  color: rgba(178, 178, 189, var(--tw-text-opacity));
}
::v-deep .month-nav .el-tabs__nav-scroll {
  margin-left: 1rem;
  margin-right: 1rem;
}
::v-deep .month-nav .el-tabs__header {
  margin-bottom: 0px;
}
</style>
